




























import { Component, Prop, Vue } from 'vue-property-decorator';

import { DbCourseManagement, DbCourseManagementDetails } from "../database/DbCourseManagement";

@Component
export default class SectionCourseManagement extends Vue {
  @Prop() currentCourseManagement?: DbCourseManagement;
  @Prop() numberOfStudents?: number;
}
